<template>
  <div>
    <input
      v-if="subtype==undefined"
      v-on:keyup.enter="mthEmitEnterPressed($event)"
      :value="valueToSee"
    />
    <input
      v-if="subtype=='cbx'"
      type="checkbox"
      @change="mthCbxSetThenEmit($event)"
      v-model="checkedIfCheckbox"
    />
  </div>
</template>

<script>
export default {
  props: ["value", "jsonpart", "index", "subtype"],
  created() {
    this.valueToSee = this.mthDetermineValueToSee(this.value, this.jsonpart);
    if(this.subtype=="cbx" && this.valueToSee=="on") this.checkedIfCheckbox=true;
  },
  data() {
    return {
      valueToSee: "",
      checkedIfCheckbox: false,
    };
  },
  methods: {
    mthCbxSetThenEmit(event){
      event.target.value="on";
      if(!this.checkedIfCheckbox) event.target.value="";
      console.log('will emit');
      console.log(event);
      this.mthEmitEnterPressed(event);
    },
    mthEmitEnterPressed(event) {
      //update model
      //var obj=JSON.parse(this.value);
      //obj[this.jsonpart]=this.valueToSee;
      console.log('event in component');
      console.log(event);

      //console.log('will emit with'+this.valueToSee);
      this.$emit("enterPressed", event);
    },
    mthDetermineValueToSee(value, jsonpart) {
      if (jsonpart === undefined || jsonpart == "") {
        return this.value;
      } else {
        var obj = JSON.parse(this.value);
        var toseepart = obj[this.jsonpart];
        return toseepart;
      }
    },
  },
};
</script>

<style scoped>
</style>